import { DeploymentType } from './deploymentTypes';
import type { RedisSupportedRegion } from './regions';

// Docs: https://cloud.google.com/memorystore/docs/redis/connect-redis-instance-cloud-run#node.js

// For Redis info see: https://console.cloud.google.com/memorystore/redis/instances?referrer=search&project=marketing-web-platform
export const redisPort = 6379;

/**
 * Mapping from region to the IP of the redis server.
 *
 * Add new ones by running:
 *
 *       export REGION=""
 *       gcloud redis instances create "redis-${REGION}" --size="1" --region="${REGION}" --project="marketing-web-platform"
 *
 * Then you can find the IP here:
 * https://console.cloud.google.com/memorystore/redis/instances?project=marketing-web-platform
 */
const productionRedisIps: Record<RedisSupportedRegion, string> = {
  'asia-northeast1': '10.165.105.235',
  'europe-west1': '10.234.14.171',
  'us-central1': '10.164.16.3',
};

/**
 * IP Address of the staging/dev redis instance.
 *
 * See: https://console.cloud.google.com/memorystore/redis/instances?project=entapps-web-dev
 */
const stagingAndDevRedisIp = '10.205.109.11';

/** Returns the IP address of the Redis/Memorystore instance for a particular region. */
export function getRedisIp(region: RedisSupportedRegion, deploymentType: DeploymentType): string {
  if (deploymentType !== DeploymentType.PRODUCTION) {
    return stagingAndDevRedisIp;
  }

  return productionRedisIps[region];
}
